module.exports = __webpack_public_path__ + "static/media/vnit-logo-220.b6824369.png";